import { FC, useState } from 'react'
import { IProjectSlot, ProjectSlotRole as IProjectSlotRole } from 'screens/Projects/projects.types'
import Button from 'shared/Buttons/Button/Button'
import css from './projectSlotRoles.module.css'
import ProjectSlotRole from './ProjectSlotRole'

interface IProps {
  slotRoles: IProjectSlotRole[]
  slotId: IProjectSlot['id']
  onChange: (value: IProjectSlotRole[]) => void
}

const defaultSlotRole = {
  maxMembers: 0,
  minMembers: 0,
  roleId: null,
  role: null,
}

const ProjectSlotRoles: FC<IProps> = (props) => {
  const [roleToAdd, setRoleToAdd] = useState(false)

  const handleAddRole = () => {
    setRoleToAdd(true)
  }

  const handleDelete = (id: IProjectSlotRole['id']) => () => {
    props.onChange(props.slotRoles.filter((s) => s.id !== id))
  }

  const handleSave = (value: IProjectSlotRole, isNew?: boolean) => {
    const roles = props.slotRoles.filter((s) => s.id !== value.id)
    props.onChange([...roles, value])

    if (isNew) {
      setRoleToAdd(false)
    }
  }

  const handleCancel = () => {
    setRoleToAdd(false)
  }

  return (
    <div className='flex-lines'>
      <div className={css.rolesListWrapper}>
        {props.slotRoles.map((role) => (
          <ProjectSlotRole
            key={role.id}
            onSave={handleSave}
            onDelete={handleDelete(role.id)}
            slotId={props.slotId}
            slotRole={role}
            id={role.id}
          />
        ))}
      </div>

      {roleToAdd && (
        <div className={css.rolesListWrapper}>
          <ProjectSlotRole
            onSave={handleSave}
            onDelete={handleCancel}
            slotId={props.slotId}
            slotRole={defaultSlotRole}
          />{' '}
        </div>
      )}

      <div className='form-footer'>
        <Button theme='primary' style={{ width: 'fit-content' }} onClick={handleAddRole} disabled={roleToAdd}>
          Добавить роль
        </Button>
      </div>
    </div>
  )
}

export default ProjectSlotRoles
